export default "__VITE_ASSET__BdhMaYRh__"